import {createSlice} from '@reduxjs/toolkit';

export const showFiltersSlice = createSlice({
  name: 'showFilters',
  initialState: {
    isActive: false,
    isFilterActive: false,
    isCompareActive: false,
    countryFilterOpened: false,
    moreFiltersOpened: false,
    activeFilters: [],
    filterCount: {count: 0},
    loaded: false,
  },
  reducers: {
    active: state => {
      state.isActive = !state.isActive;
    },
    filterActive: (state, action) => {
      state.isFilterActive = action.payload;
    },
    compareActive: (state, action) => {
      state.isCompareActive = action.payload;
    },
    inactive: state => {
      state.isActive = !state.isActive;
    },
    hasBeenLoaded: state => {
      state.loaded = true;
    },
    toggleCountryFilter: (state, action) => {
      state.countryFilterOpened = action.payload;
    },
    toggleMoreFilters: (state, action) => {
      state.moreFiltersOpened = action.payload;
    },
    changeActiveFilters: (state, action) => {
      const filters = action.payload?.filter(category => category.filteredCategories.length > 0);
      state.activeFilters = filters;
    },
    setFilterCount: state => {
      let counter = 0;
      state.filterCount = {count: 0};

      if (state.activeFilters != null) {
        state.activeFilters.forEach(category => {
          counter += category.filteredCategories.length;
          state.filterCount[category.id] = category.filteredCategories.length;
        });
      }
      state.filterCount.count = counter;
    },
    clearAllFilterCounts: state => {
      state.countryFilterCount = 0;
      state.moreFilterCount = 0;
      state.filterCount = {count: 0};
    },
    addFilteredCategory: (state, action) => {
      state.activeFilters.forEach(category => {
        if (category.id === action.payload.id) {
          category.filteredCategories.push(action.payload.filteredCategories[0]);
        }
      });
    },
    removeFilteredCategory: (state, action) => {
      const filters = state.activeFilters;

      let indexOfCountry;
      state.activeFilters.forEach(category => {
        if (category.id === action.payload.id) {
          category.filteredCategories.forEach((filteredCategory, index) => {
            if (filteredCategory.text === action.payload.filteredCategory) {
              indexOfCountry = index;
            }
          });
          category.filteredCategories.splice(indexOfCountry, 1);
        }
      });

      state.activeFilters = filters.filter(category => category.filteredCategories.length > 0);
    },
  },
});

export const {
  active,
  filterActive,
  compareActive,
  inactive,
  toggleCountryFilter,
  toggleMoreFilters,
  changeActiveFilters,
  addFilteredCategory,
  removeFilteredCategory,
  setFilterCount,
  clearAllFilterCounts,
  hasBeenLoaded,
} = showFiltersSlice.actions;

export default showFiltersSlice.reducer;
